import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a5a6514a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "notification-reconnected__block" }
const _hoisted_2 = {
  style: { width: '40px', height: '40px' },
  viewBox: "0 0 44 20",
  fill: "red",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M3.20076 19.5H8.37724L13.3849 5.02381H21L22.5754 0.5H2.13171L0.5 5.02381H8.2647L3.20076 19.5Z" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M29.697 4.99402L41.9246 5L43.5 0.5H26.468C24.9951 0.5 24.0887 1.18264 23.7488 2.6048C23.6921 2.71857 23.069 4.53893 21.8793 8.06587C21.7094 8.57785 21.5961 9.03294 21.5961 9.48803C21.5961 11.2949 23.2611 12.1617 24.8818 12.1617H33.4926C34.2857 12.1617 34.5 12.488 34.5 13C34.5 14.5 33.3633 15.006 32.303 15.006H20.0862L18.5 19.5H35.532C37.0196 19.5 37.6843 18.5907 38.2512 17.3383C38.2512 17.3383 40.5 12.1617 40.6305 10.2275C40.7611 8.29341 38.9737 7.61077 37.3448 7.61077H28.734C27.9975 7.61077 27.6576 7.38324 27.6576 6.92815C27.6576 6.30381 27.7731 5.71312 28.3374 5.33533C28.6773 5.10778 29.1305 4.99402 29.697 4.99402Z" }, null, -1))
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = { class: "notification-reconnected__information" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "notification-reconnected__message" }, "Нет соединения", -1))

import {
  TirPmButton,
  TirPmButtonSizeEnum,
  TirPmButtonVariantEnum,
  TirPmSpinner,
} from "tir-components";
import { TirPmIconView } from "tir-pm-icon-view";
import { ChartBarIcon } from "tir-style-system/icons/outline";
import { ArrowPathIcon } from "tir-style-system/icons/solid";

/**События */

export default /*#__PURE__*/_defineComponent({
  __name: 'notification-reconnected',
  emits: ["reconnect"],
  setup(__props, { emit }) {



/**Переподключится */
const reconnect = () => {
  emit("reconnect");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(TirPmIconView), {
      isBordered: false,
      class: "notification-reconnected__logo",
      colorCode: "transparent",
      size: 40
    }, {
      mainSlot: _withCtx(() => [
        (_openBlock(), _createElementBlock("svg", _hoisted_2, _hoisted_5))
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_unref(ChartBarIcon), { class: "notification-reconnected__icon" }),
      _hoisted_7,
      _createVNode(_unref(TirPmButton), {
        class: "notification-reconnected__button",
        variant: _unref(TirPmButtonVariantEnum).LinkState,
        size: _unref(TirPmButtonSizeEnum).Small,
        onClick: reconnect
      }, {
        leftSlot: _withCtx(() => [
          _createVNode(_unref(ArrowPathIcon))
        ]),
        default: _withCtx(() => [
          _createTextVNode(" Попробовать снова ")
        ]),
        _: 1
      }, 8, ["variant", "size"])
    ])
  ]))
}
}

})